
<div class="mb-2">
    <a class="btn btn-secondary" [routerLink]="['/product-amounts']">&lt; Contents</a>
</div>

<div *ngIf="ProductAmount != null; else Loading" class="card">
    <div class="card-header mfp-header">
        <div class="d-flex justify-content-between">
            <h4 class="d-inline-block align-self-center mb-0">
                Content: {{ ProductAmount.ProductAmountID }}
            </h4>
            <div class="d-inline-block">
                <button class="btn btn-secondary" (click)="EditProductAmount()">Edit</button>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-md-8 offset-md-2 col-lg-4 offset-lg-1">
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Product Type:
                        </div>
                        <div class="col-12 col-md-6 text-end">
                            {{ ProductAmount.ProductType.Name }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Batch/Blend:
                        </div>
                        <div class="col-12 col-md-6 text-end">
                            {{ ProductAmount.Batch }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Composition:
                        </div>
                        <div class="col-12 col-md-6 text-end">
                            {{ ProductAmount.Composition }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Barrel:
                        </div>
                        <div class="col-12 col-md-6 text-end">
                            {{ ProductAmount.Barrel.Name }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-8 fw-bold">
                            Date Filled:
                        </div>
                        <div class="col-12 col-md-4 text-end">
                            {{ ProductAmount.DateFilled | date:'shortDate' }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-8 fw-bold">
                            Gallons In:
                        </div>
                        <div class="col-12 col-md-4 text-end">
                            {{ ProductAmount.Gallons }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Proof in BBL:
                        </div>
                        <div class="col-12 col-md-6 text-end">
                            {{ ProductAmount.Proof }}
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-8 offset-md-2 col-lg-4 offset-lg-2">
                    <div class="row my-2">
                        <div class="col-12 col-md-8 fw-bold">
                            Wine Gallons after Angel Share:
                        </div>
                        <div class="col-12 col-md-4 text-end">
                            {{ ProductAmount.GallonsAfterAngelShare | number:'1.0-3' }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-8 fw-bold">
                            Proof Gallons after Angel Share:
                        </div>
                        <div class="col-12 col-md-4 text-end">
                            {{ ProductAmount.ProofGallonsAfterAngelShare | number:'1.0-3' }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-8 fw-bold">
                            # Bottles &#64; 100 Proof:
                        </div>
                        <div class="col-12 col-md-4 text-end">
                            {{ ProductAmount.ProofBottlesAfterAngelShare | number:'1.0-1' }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Gross Revenue:
                        </div>
                        <div class="col-12 col-md-6 text-end">
                            Coming soon!
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #Loading>
    
</ng-template>